import Yup from 'utils/validation/yup-extensions';
import Box from '@mui/material/Box';
import AppWrappedSelect from 'pages/ApplicationRequest/components/containers/AppWrappedSelect';
import AppWrappedTextbox from 'pages/ApplicationRequest/components/containers/AppWrappedTextbox';

const MAX_OTHER_LENGTH = 500;

const ANESTHESIOLOGY_VENDOR_OPTIONS = [
	{ key: '112005', value: 'PeriopAnesConsultants' },
	{ key: '1120001', value: 'BlueMtn' },
	{ key: '1120002', value: 'CommAnesAssoc' },
	{ key: '1120003', value: 'Premier' },
	{ key: '1120004', value: 'Perfusion' },
	{ key: '1120010', value: 'Employed' },
	{ key: '1120011', value: 'Contracted' },
	{ key: '1071233333', value: 'NAPA' },
	{ key: '-1', value: 'Other' },
];

export const FORM_FIELD_KEYS = {
	ANESTHESIOLOGY_VENDOR: 'ANESTHESIOLOGY_VENDOR',
	ANESTHESIOLOGY_OTHER: 'ANESTHESIOLOGY_OTHER',
};

export const INITIAL_VALUES = {
	[FORM_FIELD_KEYS.ANESTHESIOLOGY_VENDOR]: '',
	[FORM_FIELD_KEYS.ANESTHESIOLOGY_OTHER]: '',
};

export const VALIDATION_SCHEMA = {
	[FORM_FIELD_KEYS.ANESTHESIOLOGY_VENDOR]: Yup.string().required(
		'Please select a vendor.',
	),
	[FORM_FIELD_KEYS.ANESTHESIOLOGY_OTHER]: Yup.string().when(
		FORM_FIELD_KEYS.ANESTHESIOLOGY_VENDOR,
		{
			is: 'Other',
			then: schema =>
				schema
					.required('Please specify the vendor.')
					.max(
						MAX_OTHER_LENGTH,
						`You have exceeded the character count (${MAX_OTHER_LENGTH}).`,
					),
			otherwise: schema => schema.notRequired(),
		},
	),
};

/**
 * Anesthesiology vendor supplement form fields.
 * @param {{ formik: import('formik').FormikProps<object> }} props
 */
export const AnesthesiologySupplement = ({ formik }) => {
	const vendorValue = formik.values[FORM_FIELD_KEYS.ANESTHESIOLOGY_VENDOR];

	return (
		<Box>
			<AppWrappedSelect
				name={FORM_FIELD_KEYS.ANESTHESIOLOGY_VENDOR}
				label='Anesthesiology Vendor'
				formik={formik}
				options={ANESTHESIOLOGY_VENDOR_OPTIONS}
				isRequired
			/>
			{vendorValue === 'Other' && (
				<AppWrappedTextbox
					name={FORM_FIELD_KEYS.ANESTHESIOLOGY_OTHER}
					label='Other Anesthesiology Provider'
					formik={formik}
					isRequired
					maxLength={MAX_OTHER_LENGTH}
					inputProps={{ maxLength: MAX_OTHER_LENGTH }}
				/>
			)}
		</Box>
	);
};
